import { lt } from '@mews/framework';
import { Amount } from '@mews-commander/data-access';
import { ConvertedCurrencyValue } from '@mews-commander/ui';
import { PaymentLinkDetailItem } from './PaymentLinkDetailItem';

export const BillAmountInfoRow = ({ billAmount }: { billAmount: Amount }) => (
    <PaymentLinkDetailItem description={lt('BillAmount')} value={<ConvertedCurrencyValue amount={billAmount} />} />
);
